import _get from "lodash/get";
import _some from "lodash/some";

export const geoJsonIs3D = (features) => {
  return _some(features, (feature) => {
    const coordinates = _get(feature, "geometry.coordinates[0]", []);
    return _some(coordinates, (coord) => coord.length > 2);
  });
};

// for feature in feature collection, ensure it has a valid id
export function ensureIds(collection) {
  if (!collection) {
    return { type: "FeatureCollection", features: [] };
  }
  const features = collection.features.map((feature) => {
    if (!feature.id) {
      feature.id = crypto.randomUUID();
    }
    return feature;
  });
  return { type: "FeatureCollection", features };
}
